{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Se alle indstillinger",
  "Spoiler_Reveal_Tooltip": "Klik for at vise",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweet dette",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Element udvides",
  "Spoiler_Reveal_Video_CTA": "Afslør video",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Udvid billedet",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Se alle resultater",
  "Spoiler_Reveal_Image_Placeholder": "Dette billede indeholder en spoiler",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Skydeknap til søgning",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Du kan stemme på mere end et svar.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Vis flere lydknapper",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Luk",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Indlæser {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Brug avatar",
  "Preview_ReadMore_Label": "Læs mere",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volumen",
  "Spoiler_Reveal_Gallery_Placeholder": "Dette galleri indeholder en spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Book nu",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Lydløs fra",
  "Spoiler_Reveal_Gallery_CTA": "Afslør galleri",
  "Poll_Viewer_ShowLess_CTA": "Vis mindre",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Lydløs til",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonym(e)",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Følg",
  "VerticalEmbed_Products_Button": "Køb nu",
  "Poll_Viewer_Toast_Error_ServerDown": "Kunne ikke forbinde til server. Prøv igen senere.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} person(er) stemte på dette svar",
  "Poll_Viewer_VoteCount": "{{number}} stemmer",
  "VerticalEmbed_Events_Button": "Tilmeld dig",
  "Spoiler_Reveal_Image_CTA": "Afslør billede",
  "Poll_Viewer_Toast_Error_Connection": "Ingen internetforbindelse. Kontroller din forbindelse.",
  "Poll_Viewer_Visibility_Owner_Footer": "Det er kun dig, der kan se resultaterne.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} stemte på dette svar",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Element udvides",
  "Audio_Plugin_Cover_Alt": "Lydcover",
  "Spoiler_Reveal_Video_Placeholder": "Denne video indeholder en spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Se hele indlægget",
  "UploadFile_Viewer_Download": "Download {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} t",
  "VerticalEmbed_Units_Minute": "{{minutes}} min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
